const e = [
  "value",
  "searchValue",
  "inputIcon",
  "clearIcon",
  "removeIcon",
  "className",
  "onChange",
  "onMouseEnter",
  "onMouseLeave",
  "onClear",
  "loading",
  "notFoundContent",
  "listHeight",
  "filterOption",
  "searchByLabel",
  "dropdownClassName",
  "shouldEscape",
  "showRequired",
  "onClick",
  "onSearch",
  "allowClear"
];
export {
  e as omitPropsKeys
};
//# sourceMappingURL=const.mjs.map
